import {DocumentData, QueryDocumentSnapshot, SnapshotOptions} from "firebase/firestore"

export class Vote {
    static converter = {
        toFirestore  : (vote: Vote): DocumentData => {
            return {
                session: vote.sessionKey || null,
                user   : vote.userKey || null,
                song   : vote.songKey || null,
                dt     : vote.dt || null
            }
        },
        fromFirestore: (snapshot: QueryDocumentSnapshot<DocumentData>, options?: SnapshotOptions): Vote => {
            return new Vote(snapshot.id, snapshot.data(options))
        }
    }
    key?: string
    sessionKey?: string
    userKey?: string
    songKey?: string
    dt?: Date

    constructor(key?: string, data?: DocumentData) {
        if (key && data) {
            this.key = key
            this.sessionKey = data.session
            this.userKey = data.user
            this.songKey = data.song
            this.dt = data.dt
        }
    }
}
